import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var AdditionalAssistanceType =
/*#__PURE__*/
function (_BaseData) {
  _inherits(AdditionalAssistanceType, _BaseData);

  function AdditionalAssistanceType() {
    _classCallCheck(this, AdditionalAssistanceType);

    return _possibleConstructorReturn(this, _getPrototypeOf(AdditionalAssistanceType).call(this, "AdditionalAssistanceType"));
  }

  return AdditionalAssistanceType;
}(BaseData);

export default new AdditionalAssistanceType();